import { render, staticRenderFns } from "./ActivityPanelDetailsPanelFooter.vue?vue&type=template&id=e5c3f088&scoped=true&"
import script from "./ActivityPanelDetailsPanelFooter.vue?vue&type=script&lang=js&"
export * from "./ActivityPanelDetailsPanelFooter.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPanelDetailsPanelFooter.vue?vue&type=style&index=0&id=e5c3f088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c3f088",
  null
  
)

export default component.exports